import styled from 'styled-components'
import { Link as AnimateScroll } from 'react-scroll'

const TextLink = styled(AnimateScroll)`
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`

TextLink.displayName = 'TextLink'

export { TextLink }
